import { StyleSheet, View } from '@react-pdf/renderer';

import { Td } from '../../../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../../../components/PdfExportV2/Text/Text.tsx';
import { Tr } from '../../../../../components/PdfExportV2/Tr/Tr.tsx';
import { selectManufacturedCostApproachTableData } from '../../../../../redux/features/selectors/costApproachSelectors/selectManufacturedCostApproachTableData.ts';
import { ExportCostApproachRollupRow } from '../ExportCostApproachRollupRow.tsx';
import { textStyleOverrides } from '../consts.ts';
import { makeColSpan } from '../utils/makeColSpan.ts';
import { ManufacturedCostApproachTableRow } from './ExportManufacturedCostApproachTableRow.tsx';
import { ExportManufacturedCostApproachTableSectionRow } from './ExportManufacturedCostApproachTableSectionRow.tsx';

const styles = StyleSheet.create({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '600px',
  },
});

type Props = {
  tableData: ReturnType<typeof selectManufacturedCostApproachTableData>;
};

export function ExportManufacturedCostApproachTable({ tableData }: Props) {
  return (
    <View style={styles.tableContainer}>
      <Tr>
        <Td style={{ width: makeColSpan(0, 1), border: 'none' }}>
          <Text variant="body1" {...textStyleOverrides}>
            {tableData.columnHeaders.left}
          </Text>
        </Td>
        <Td style={{ width: makeColSpan(0, 1), border: 'none' }}>
          <Text variant="body1" {...textStyleOverrides}>
            {tableData.columnHeaders.right}
          </Text>
        </Td>
      </Tr>
      <ExportCostApproachRollupRow
        label={tableData.opinionOfSiteValue.label}
        value={tableData.opinionOfSiteValue.value}
        isFirstRow
        isBold
        showEquals={false}
      />
      <ExportManufacturedCostApproachTableSectionRow data={tableData.sectionOne} />
      <ExportManufacturedCostApproachTableSectionRow data={tableData.sectionTwo} />
      <ExportManufacturedCostApproachTableSectionRow data={tableData.sectionThree} />
      <ExportManufacturedCostApproachTableSectionRow data={tableData.sectionFour} />
      {tableData.structures.map((structure) => (
        <ManufacturedCostApproachTableRow key={structure.label} data={structure} />
      ))}
      <ManufacturedCostApproachTableRow data={tableData.subTotal} bold />
      <ManufacturedCostApproachTableRow data={tableData.costMultiplier} />
      <ManufacturedCostApproachTableRow data={tableData.modifiedSubTotal} bold />
      <ManufacturedCostApproachTableRow data={tableData.physicalDepreciation} />
      <ManufacturedCostApproachTableRow data={tableData.functionalObsolescence} />
      <ManufacturedCostApproachTableRow data={tableData.externalDepreciation} />
      <ManufacturedCostApproachTableRow data={tableData.deliveryInstallationSetup} />
      <ManufacturedCostApproachTableRow data={tableData.otherDepreciatedImprovements} />
      <ManufacturedCostApproachTableRow data={tableData.marketValue} />
      <ManufacturedCostApproachTableRow data={tableData.indicatedValue} bold />
    </View>
  );
}
